import { render, staticRenderFns } from "./MultipleChoiceSingleAnswerWithValueQuestion.vue?vue&type=template&id=8a2014fa&scoped=true&"
import script from "./MultipleChoiceSingleAnswerWithValueQuestion.vue?vue&type=script&lang=js&"
export * from "./MultipleChoiceSingleAnswerWithValueQuestion.vue?vue&type=script&lang=js&"
import style0 from "./MultipleChoiceSingleAnswerWithValueQuestion.vue?vue&type=style&index=0&id=8a2014fa&prod&lang=scss&scoped=true&"
import style1 from "./MultipleChoiceSingleAnswerWithValueQuestion.vue?vue&type=style&index=1&id=8a2014fa&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8a2014fa",
  null
  
)

export default component.exports